var map = {
	"./": 173,
	"./App": 237,
	"./App.css": 1377,
	"./App.js": 237,
	"./App.scss": 517,
	"./bufficorn.png": 1378,
	"./burnerloader.gif": 347,
	"./burnerwallet.png": 349,
	"./coinbase.jpg": 1379,
	"./components/Admin": 253,
	"./components/Admin.js": 253,
	"./components/Advanced": 252,
	"./components/Advanced.js": 252,
	"./components/Badge": 101,
	"./components/Badge.js": 101,
	"./components/Badges": 136,
	"./components/Badges.js": 136,
	"./components/Balance": 40,
	"./components/Balance.js": 40,
	"./components/BalanceDisplay": 542,
	"./components/BalanceDisplay.jsx": 542,
	"./components/Bottom": 41,
	"./components/Bottom.js": 41,
	"./components/BottomLinks": 320,
	"./components/BottomLinks.js": 320,
	"./components/BurnWallet": 257,
	"./components/BurnWallet.js": 257,
	"./components/CashOut": 249,
	"./components/CashOut.js": 249,
	"./components/Exchange": 258,
	"./components/Exchange.js": 258,
	"./components/Footer": 256,
	"./components/Footer.js": 256,
	"./components/Header": 238,
	"./components/Header.js": 238,
	"./components/History": 251,
	"./components/History.js": 251,
	"./components/Loader": 120,
	"./components/Loader.js": 120,
	"./components/MainCard": 250,
	"./components/MainCard.js": 250,
	"./components/Modal": 543,
	"./components/Modal.js": 543,
	"./components/MoreButtons": 119,
	"./components/MoreButtons.js": 119,
	"./components/NavCard": 36,
	"./components/NavCard.js": 36,
	"./components/Receipt": 248,
	"./components/Receipt.js": 248,
	"./components/Receive": 245,
	"./components/Receive.js": 245,
	"./components/RecentTransactions": 93,
	"./components/RecentTransactions.js": 93,
	"./components/RequestFunds": 243,
	"./components/RequestFunds.js": 243,
	"./components/Ruler": 18,
	"./components/Ruler.js": 18,
	"./components/SendBadge": 241,
	"./components/SendBadge.js": 241,
	"./components/SendByScan": 239,
	"./components/SendByScan.js": 239,
	"./components/SendToAddress": 240,
	"./components/SendToAddress.js": 240,
	"./components/SendWithLink": 244,
	"./components/SendWithLink.js": 244,
	"./components/Share": 246,
	"./components/Share.js": 246,
	"./components/ShareLink": 247,
	"./components/ShareLink.js": 247,
	"./components/Vendor": 254,
	"./components/Vendor.js": 254,
	"./components/Vendors": 255,
	"./components/Vendors.js": 255,
	"./components/WithdrawFromPrivate": 242,
	"./components/WithdrawFromPrivate.js": 242,
	"./contracts/Badges.abi": 322,
	"./contracts/Badges.abi.js": 322,
	"./contracts/Badges.address": 330,
	"./contracts/Badges.address.js": 330,
	"./contracts/Badges.blocknumber": 544,
	"./contracts/Badges.blocknumber.js": 544,
	"./contracts/Badges.bytecode": 545,
	"./contracts/Badges.bytecode.js": 545,
	"./contracts/ENS.abi": 231,
	"./contracts/ENS.abi.js": 231,
	"./contracts/ENS.address": 235,
	"./contracts/ENS.address.js": 235,
	"./contracts/ENS.blocknumber": 546,
	"./contracts/ENS.blocknumber.js": 546,
	"./contracts/ENSResolver.abi": 232,
	"./contracts/ENSResolver.abi.js": 232,
	"./contracts/ENSResolver.blocknumber": 547,
	"./contracts/ENSResolver.blocknumber.js": 547,
	"./contracts/ERC20Vendable.abi": 323,
	"./contracts/ERC20Vendable.abi.js": 323,
	"./contracts/ERC20Vendable.address": 331,
	"./contracts/ERC20Vendable.address.js": 331,
	"./contracts/ERC20Vendable.blocknumber": 548,
	"./contracts/ERC20Vendable.blocknumber.js": 548,
	"./contracts/ERC20Vendable.bytecode": 549,
	"./contracts/ERC20Vendable.bytecode.js": 549,
	"./contracts/Emitter.abi": 233,
	"./contracts/Emitter.abi.js": 233,
	"./contracts/Emitter.address": 236,
	"./contracts/Emitter.address.js": 236,
	"./contracts/Emitter.blocknumber": 550,
	"./contracts/Emitter.blocknumber.js": 550,
	"./contracts/Emitter.bytecode": 551,
	"./contracts/Emitter.bytecode.js": 551,
	"./contracts/Exchange.abi": 230,
	"./contracts/Exchange.abi.js": 230,
	"./contracts/Exchange.address": 332,
	"./contracts/Exchange.address.js": 332,
	"./contracts/Exchange.blocknumber": 552,
	"./contracts/Exchange.blocknumber.js": 552,
	"./contracts/GnosisSafe.abi": 324,
	"./contracts/GnosisSafe.abi.js": 324,
	"./contracts/GnosisSafe.address": 333,
	"./contracts/GnosisSafe.address.js": 333,
	"./contracts/GnosisSafe.blocknumber": 553,
	"./contracts/GnosisSafe.blocknumber.js": 553,
	"./contracts/GnosisSafe.bytecode": 554,
	"./contracts/GnosisSafe.bytecode.js": 554,
	"./contracts/Links.abi": 325,
	"./contracts/Links.abi.js": 325,
	"./contracts/Links.address": 334,
	"./contracts/Links.address.js": 334,
	"./contracts/Links.blocknumber": 555,
	"./contracts/Links.blocknumber.js": 555,
	"./contracts/Links.bytecode": 556,
	"./contracts/Links.bytecode.js": 556,
	"./contracts/LinksNFT.abi": 326,
	"./contracts/LinksNFT.abi.js": 326,
	"./contracts/LinksNFT.address": 335,
	"./contracts/LinksNFT.address.js": 335,
	"./contracts/LinksNFT.blocknumber": 557,
	"./contracts/LinksNFT.blocknumber.js": 557,
	"./contracts/LinksNFT.bytecode": 558,
	"./contracts/LinksNFT.bytecode.js": 558,
	"./contracts/ProxyFactory.abi": 327,
	"./contracts/ProxyFactory.abi.js": 327,
	"./contracts/ProxyFactory.address": 336,
	"./contracts/ProxyFactory.address.js": 336,
	"./contracts/ProxyFactory.blocknumber": 559,
	"./contracts/ProxyFactory.blocknumber.js": 559,
	"./contracts/ProxyFactory.bytecode": 560,
	"./contracts/ProxyFactory.bytecode.js": 560,
	"./contracts/SafeBeacon.abi": 328,
	"./contracts/SafeBeacon.abi.js": 328,
	"./contracts/SafeBeacon.address": 337,
	"./contracts/SafeBeacon.address.js": 337,
	"./contracts/SafeBeacon.blocknumber": 561,
	"./contracts/SafeBeacon.blocknumber.js": 561,
	"./contracts/SafeBeacon.bytecode": 562,
	"./contracts/SafeBeacon.bytecode.js": 562,
	"./contracts/StableCoin.abi": 234,
	"./contracts/StableCoin.abi.js": 234,
	"./contracts/StableCoin.address": 338,
	"./contracts/StableCoin.address.js": 338,
	"./contracts/StableCoin.blocknumber": 563,
	"./contracts/StableCoin.blocknumber.js": 563,
	"./contracts/StableCoin.bytecode": 564,
	"./contracts/StableCoin.bytecode.js": 564,
	"./contracts/VendingMachine.abi": 329,
	"./contracts/VendingMachine.abi.js": 329,
	"./contracts/VendingMachine.address": 339,
	"./contracts/VendingMachine.address.js": 339,
	"./contracts/VendingMachine.blocknumber": 565,
	"./contracts/VendingMachine.blocknumber.js": 565,
	"./contracts/VendingMachine.bytecode": 566,
	"./contracts/VendingMachine.bytecode.js": 566,
	"./contracts/contracts": 567,
	"./contracts/contracts.js": 567,
	"./core": 17,
	"./core.js": 17,
	"./customRPCHint.png": 351,
	"./cypherpunk.png": 352,
	"./daog.png": 94,
	"./i18n": 1,
	"./i18n/": 1,
	"./i18n/index": 1,
	"./i18n/index.js": 1,
	"./i18n/locales": 52,
	"./i18n/locales/": 52,
	"./i18n/locales/ca": 218,
	"./i18n/locales/ca.json": 218,
	"./i18n/locales/de": 219,
	"./i18n/locales/de.json": 219,
	"./i18n/locales/en": 215,
	"./i18n/locales/en.json": 215,
	"./i18n/locales/es": 217,
	"./i18n/locales/es.json": 217,
	"./i18n/locales/fr": 216,
	"./i18n/locales/fr.json": 216,
	"./i18n/locales/he": 221,
	"./i18n/locales/he.json": 221,
	"./i18n/locales/index": 52,
	"./i18n/locales/index.js": 52,
	"./i18n/locales/it": 226,
	"./i18n/locales/it.json": 226,
	"./i18n/locales/ja": 224,
	"./i18n/locales/ja.json": 224,
	"./i18n/locales/pt": 223,
	"./i18n/locales/pt.json": 223,
	"./i18n/locales/ro": 220,
	"./i18n/locales/ro.json": 220,
	"./i18n/locales/ru": 222,
	"./i18n/locales/ru.json": 222,
	"./i18n/locales/zh": 225,
	"./i18n/locales/zh.json": 225,
	"./i18n/locales/zh_TW": 568,
	"./i18n/locales/zh_TW.json": 568,
	"./images/dai.jpg": 166,
	"./images/ethereum.png": 117,
	"./images/xdai.jpg": 139,
	"./index": 173,
	"./index.js": 173,
	"./index.scss": 357,
	"./localeth.png": 1380,
	"./qrcode.png": 348,
	"./sendwyre.png": 1381,
	"./services/incogDetect": 259,
	"./services/incogDetect.js": 259,
	"./services/wyre": 137,
	"./services/wyre.js": 137,
	"./wyre.jpg": 1382,
	"./wyre.png": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1376;